import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {DocumentTemplateModel} from '../../../api/entity/documentTemplate.model';

@Injectable({
    providedIn: 'root'
})
export class DocumentTemplateRepository extends AbstractRepositoryV2<DocumentTemplateModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('DocumentTemplate', serviceElementsFactory, injector);
    }
}
